module.exports = __webpack_public_path__ + "img/wishtour.ebe79d73.png";